// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "#modalCheckoutErrorMessage{text-align:center}", "",{"version":3,"sources":["webpack://./js.autoload/vueComponents/checkout/checkout.vue"],"names":[],"mappings":"AAAA,2BAA2B,iBAE3B","sourcesContent":["#modalCheckoutErrorMessage{text-align:center}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
